/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_ErrorsInputs */

const fr_legal_privacy_errors = /** @type {(inputs: Legal_Privacy_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs levées dans le cadre de l'exécution de l'application`)
};

const en_legal_privacy_errors = /** @type {(inputs: Legal_Privacy_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors raised while the application is running`)
};

/**
* | output |
* | --- |
* | "Errors raised while the application is running" |
*
* @param {Legal_Privacy_ErrorsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_errors = /** @type {((inputs?: Legal_Privacy_ErrorsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_ErrorsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_errors(inputs)
	return en_legal_privacy_errors(inputs)
});